import { STRINGS } from '@/constants/strings';
import { PRIVACY_POLICY_HTML } from '@/features/auth/components/legal/privacy-policy';
import { TERMS_OF_SERVICE_HTML } from '@/features/auth/components/legal/terms-of-service';
import type { LegalDocumentApiType } from '@/services/get-legal-documents';

export { PRIVACY_POLICY_HTML } from '@/features/auth/components/legal/privacy-policy';
export { TERMS_OF_SERVICE_HTML } from '@/features/auth/components/legal/terms-of-service';

/** Identifies which legal document the popup should display. */
export type LegalDocumentType = 'terms' | 'privacy';

const strings = STRINGS.auth.legal;

/** Title + HTML body for each legal document, keyed by {@link LegalDocumentType}.
 *
 *  Only a fallback now: the live copy comes from `GET /api/v1/legal-documents/{type}`. It is
 *  kept so a failed request still shows the policy the build shipped with rather than a blank
 *  card. */
export const LEGAL_DOCUMENTS: Record<LegalDocumentType, { title: string; html: string }> = {
  terms: { title: strings.termsTitle, html: TERMS_OF_SERVICE_HTML },
  privacy: { title: strings.privacyTitle, html: PRIVACY_POLICY_HTML },
};

/** The API names its documents differently from the popup's keys. */
export const LEGAL_DOCUMENT_API_TYPE: Record<LegalDocumentType, LegalDocumentApiType> = {
  terms: 'terms_of_service',
  privacy: 'privacy_policy',
};
